import * as React from "react"

import Seo from "../components/Seo"
import Hero from '../components/Hero'
import Sidebar from '../components/Sidebar'
import Widget from '../components/Widget'
import SignUpSection from '../components/SignUpSection'
import { graphql } from "gatsby"
import SidebarWidget from "../components/SidebarWidget"
import { StaticImage } from "gatsby-plugin-image"

const displayWidgets = (widgets) => (
  widgets.map( widget => (
    <Widget
      key={ widget.widget_link_url }
      headline={ widget.widget_title } 
      text={ widget.widget_content } 
      label={ widget.widget_link_label }  
      link={ widget.widget_link_url }  
    />
  ))
)

const replaceHeading = (article, heading) => {
  let newArticle = '';
  newArticle = article.replace('<h2>', `<h2 id="${heading.value}">`);
  return newArticle;
}

export default function votingResidents({ data }) {

  // = = = = = = = = 
  // Forestry Data
  const residentsData = data.markdownRemark.frontmatter;
  const headings = data.markdownRemark.headings;
  let article = data.markdownRemark.html;
  const showWidgets = data.markdownRemark.frontmatter.would_you_like_to_show_widgets_bellow_the_main_article;
  const widgets = data.markdownRemark.frontmatter.bellow_article_widgets;

  
  // = = = = = = = = 
  // Utils

  // Add Heading as an ID to each headline
  headings.forEach( heading => {
    article = replaceHeading(article, heading);
  });

  return(
    <>
      <Seo title = { residentsData.page_title } />

      <Hero 
        headline = { residentsData.hero_headline }
        intro = { residentsData.hero_intro }
        image = { residentsData.hero_background_image }
      >
        <StaticImage 
          className="hero__picture"
          src="../../static/media/about-hero.jpg" 
          alt="" 
          loading="eager"
        />
      </Hero>

      <div className="page-content">
        <div className="container">
          <div className="row">

            <div className="col-md-3">
              <Sidebar 
                headings = { data.markdownRemark.headings } 
                links = { residentsData.sidebar_links }>
                  
                  <SidebarWidget 
                    headline="Become a Voter"
                    linkLabel="Express your interest"
                    link="/voting"
                  >
                    <StaticImage 
                      className="sidebar__widget__image" 
                      src="../images/sidebar-widget.jpg" 
                      alt=""
                    />
                  </SidebarWidget>

              </Sidebar>
            </div>

            <div className="col-md-9">
              <article dangerouslySetInnerHTML={{__html: article }} />
              
              {
                showWidgets === true
                  ? displayWidgets(widgets)
                  :''
              }
              
            </div>

          </div>
        </div>
      </div>

      <SignUpSection />
    </>
  )
}

// = = = = = = = = 
// GraphQL
export const query = graphql`
  query ResidentsQuery {
    markdownRemark(frontmatter: {page_title: {eq: "Voting Residents"}}) {
      frontmatter {
        page_title
        hero_headline
        hero_intro
        sidebar_links {
          link_label
          link_url
        }
        would_you_like_to_show_widgets_bellow_the_main_article
        bellow_article_widgets {
          widget_title
          widget_content
          widget_link_label
          widget_link_url
        }
      }
      headings(depth: h2) {
        value
      }
      html
    }
  }
`;